const handleInputChange = ({ setSuggestedValue, setEnteredValue, isNavigated, setIsNavigated, setOn }) => (e) => {
    const inputValue = e.target.value;
    setSuggestedValue(inputValue);
    setEnteredValue(inputValue);
    isNavigated && setIsNavigated(false);
    setOn();
};
export default handleInputChange;
//# sourceMappingURL=handleInputChange.js.map